import {
    SALEORDERS_SUCCESSFUL_GET,
    SALEORDERS_UPDATE_FILTERCUSTOMER,
    SALEORDERS_UPDATE_FILTERSTATUS,
    SALEORDERS_UPDATE_FILTERSTARTDATE,
    SALEORDERS_UPDATE_FILTERENDDATE
} from 'reducers/constants';

const initialState = {
    /*saleOrdersDto: {
        count: 0,
        data: []
    },*/
    saleOrdersDto: null,
    filterCustomer: null,
    filterStartDate: "",
    filterEndDate: "",
    filterOrderStatus: null
}

export default function (state = initialState, action) {
    switch (action.type) {

        case SALEORDERS_SUCCESSFUL_GET:
            return {
                ...state,
                saleOrdersDto: Object.assign({}, action.payload)
            }

        case SALEORDERS_UPDATE_FILTERCUSTOMER:
            return {
                ...state,
                filterCustomer: action.payload != null ? action.payload : null
            }

        case SALEORDERS_UPDATE_FILTERSTATUS:
            return {
                ...state,
                filterOrderStatus: action.payload != null ? action.payload : null
            }

        case SALEORDERS_UPDATE_FILTERSTARTDATE:
            return {
                ...state,
                filterStartDate: action.payload != "" ? action.payload : ""
            }

        case SALEORDERS_UPDATE_FILTERENDDATE:
            return {
                ...state,
                filterEndDate: action.payload != "" ? action.payload : ""
            }
        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/saleorders/saleordersReducer.js